import React, { useState, useEffect }  from 'react'
import './eswearing.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { useNavigate,Link , useParams  } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import * as Constants from '../../constants';
import BackLoader from '../../components/backloader'
import { Button } from '@mui/material'

function ApproveFiles() {

    //if type = fee/case attach id will be used properly
    const {type} = useParams();//case or fee
    const {id} = useParams();

    
    var url= `${Constants.apiUrl}/gazette/ApprovedDocuments/${type}/${id}`;
    const [files, setFiles] = useState([]);
    const [caseInfo, setCaseInfo]=useState({});
    const [isLoading,setIsLoading]= useState(false);


    const navigate = useNavigate();
    useEffect(() => {
        onLoad()
       
      }, []);


      const onLoad= async()=>{
        //for account registration
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            console.log(data);
            if(data.code==0){
                setFiles(data.files);
                setCaseInfo(data.caseinfo)
            }
            setIsLoading(false);
          
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }


   
  return (
    <div className='e-swearing'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>Documents</h2>
                    </div>
                    <p>Documents attach to {type}</p>
                </div>
                <p className="nav-status">Home/Specifications/e-Swearing-Schedule</p>
            </div>
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            {/* <th>ID</th> */}
                            
                            <th>Document Name </th>
                            <th> Paid</th>
                           
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        { files.map((item, id) => { return (
                            <tr key={id}>
                                {/* <td>{item.id}</td> */}
                                <td>{item.documentName}</td>
                                <td>{item.isPaidStatus}</td>
                                <td > <a href={`${Constants.primary_doc_file}/${item.documentLocation}/${item.documentName}`} target='_blank'>View Document</a></td>
                              
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>
            <div className="down">
                <div className="goBack" onClick={() => navigate('/dashboard') }>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <p>Back to Home</p>
                </div>
            </div>
        </div>
        <BackLoader open={isLoading}  />
    </div>
  )
}

export default ApproveFiles